import axios from 'axios'
import encodedURIComponentQueryStringConverter from '../../utils/encodedURIComponentQueryString'

const getUrlStringFromParamObject = (url = '/', params = {}) => {
  const newUrl = encodedURIComponentQueryStringConverter(url, params?.params ? params.params : params)
  return newUrl
}

const fetcher = init => async (url = '/', params = {}) => {
  const newURL = encodedURIComponentQueryStringConverter(
    url,
    params.queryParams
  )
  const newParams = { ...params }
  if (newParams.queryParams) {
    delete newParams.queryParams
  }
  return axios({ url: newURL, ...init, ...newParams })
    .then(response => {
      return Promise.resolve(response.data)
    })
    .catch(error => {
      console.error(error)
      const err = new Error(error?.response?.data?.message?.data?.message)
      err.code = error?.response?.data?.message?.data?.code
      return Promise.reject(err)
    })
}

// use the following methods by passing relative url like '/product' as the first param and param object as the second.
// the param object can contain queryParams, body, headers
// example params = {queryParams: {storeId: 1}, headers: { 'content-type': 'application/json' }, body: {organizationId: 4}}

const get = fetcher({ method: 'get' })

const post = fetcher({ method: 'post' })

const put = fetcher({ method: 'put' })

const del = fetcher({ method: 'delete' })

export { get, put, post, del, getUrlStringFromParamObject }
